import React, {Component} from 'react'
import {FormGroup, Checkbox, Col, ControlLabel, Button} from 'react-bootstrap'
import PropTypes from 'prop-types'

export default class MultiCheckboxField extends Component {

	constructor(props) {
		super(props);

		this.state = {showingSelected: true}
	}

	static propTypes = {
		showOnlySelected: PropTypes.bool,
		options: PropTypes.arrayOf(PropTypes.shape({
			label: PropTypes.any.isRequired,
			value: PropTypes.any.isRequired
		})).isRequired
	};

	render() {
		const {input, meta, options, showOnlySelected, sizes, label, emptyText, vertical = false} = this.props;
		const {name, onChange} = input;
		const {touched, error} = meta;
		const inputValue = input.value;

		const checkboxes = options.map(({label, value, className = null}, index) => {

			const handleChange = (event) => {
				const arr = [...inputValue];
				if (event.target.checked) {
					arr.push(value)
				}
				else {
					arr.splice(arr.indexOf(value), 1)
				}
				return onChange(arr)
			};
			const checked = inputValue.includes(value);
			return (
				<Checkbox key={`checkbox-${index}`} name={`${name}[${index}]`} value={value} checked={checked} onChange={handleChange} inline={true}
					className={showOnlySelected && this.state.showingSelected && !checked ? "hidden" : className}>
					<span className={checked ? "text-bolder" : ""}>{label}</span>
				</Checkbox>
			)
		});

		if (showOnlySelected) {
			if (this.state.showingSelected) {
				if (!inputValue || !inputValue.length) {
					checkboxes.push(<i key="none" className="checkbox-inline" style={{marginLeft: 0, paddingLeft: 0}}>{emptyText ? emptyText : "Nic nevybráno"}</i>)
				}
				checkboxes.push(<Button key="button" bsStyle="default" className="btn-xs" type="button" style={{margin: "3px 0 -3px 7px"}} onClick={() => {
					this.setState({showingSelected: false})
				}}>Zobrazit vše</Button>)
			} else {
				checkboxes.push(<Button key="button" bsStyle="default" className="btn-xs" type="button" style={{margin: "3px 0 -3px 7px"}} onClick={() => {
					this.setState({showingSelected: true})
				}}>Ukrýt nevybrané</Button>)
			}
		}

		return (
			<FormGroup controlId={input.name}>
				{label ? <Col xs={sizes && sizes[0] ? sizes[0] : 4} componentClass={ControlLabel}>{label}</Col> : null}
				<Col xs={label ? (sizes && sizes[1] ? sizes[1] : 8) : (sizes && sizes[0] ? sizes[0] : 12)}>
					<div className={vertical ? 'checkbox-vertical' : null}>{checkboxes}</div>
					{touched && error && <p className="error">{error}</p>}
				</Col>
			</FormGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/form/MultiCheckboxField.js